import React, { FC } from 'react'

import { Grid, Theme, CircularProgress } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'fixed',
    zIndex: 1000,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.3)',
  },
  bottom: {
    color: theme.palette.grey[theme.palette.mode === 'dark' ? 200 : 700],
    position: 'fixed',
  },
  top: {
    color: '#6BFFBF',
    animationDuration: '550ms',
    position: 'fixed',
  },
  circle: {
    strokeLinecap: 'round',
  },
}))

export const Loader: FC = () => {
  const classes = useStyles()
  return (
    <Grid container className={classes.root}>
      <CircularProgress variant="determinate" className={classes.bottom} size={40} thickness={4} value={100} />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        className={classes.top}
        classes={{
          circle: classes.circle,
        }}
        size={40}
        thickness={4}
      />
    </Grid>
  )
}
